import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FloatingBubbleModal.css'; // reutilizamos estilos
import { useSelector } from 'react-redux';
import moment from 'moment';
import { jwtDecode } from 'jwt-decode';
import API_BASE_URL from '../config';





const FloatingVuelosModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [vuelos, setVuelos] = useState([]);
    const [formData, setFormData] = useState({
      fechaVuelo: new Date().toISOString().split('T')[0],
      aerolinea: '',
      noVuelo: '',
      int_nac: ''
    });
  
    const token = useSelector((state) => state.auth.token);
    const decoded = token ? jwtDecode(token) : {};
    const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'GDL';
  
    console.log("🧪 Token decodificado:", decoded);

    const aerolineasPorEstacion = {
        GDL: ["AM", "DL", "UA", "AA"],
        PVR: ["AM", "UA", "F8", "F9", "DL", "CNT", "TA", "AC"],
        MTY: ["AA", "DL", "SW"],
        MEXT1: ["UA", "AV", "IB", "HN", "TK","AC", "CZ", "HU", "LH", "EK", "NH"],
        MEXT2:["DL","AM"],
        CUN: ["AM", "UA", "DL"],
      };
  
    const aerolineasDisponibles = aerolineasPorEstacion[estacionUsuario] || aerolineasPorEstacion.DEFAULT;
  
    const fetchVuelos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/vuelos`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setVuelos(response.data);
      } catch (error) {
        console.error('Error al obtener vuelos:', error);
      }
    };
  
    const eliminarVuelo = async (id) => {
      if (!window.confirm('¿Estás seguro de eliminar este vuelo?')) return;
      try {
        await axios.delete(`${API_BASE_URL}api/vuelos/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchVuelos();
      } catch (error) {
        console.error('Error al eliminar vuelo:', error);
        alert('No se pudo eliminar el vuelo');
      }
    };
  
    useEffect(() => {
      if (isModalOpen) {
        fetchVuelos();
      }
    }, [isModalOpen]);
  
    const handleGuardarVuelo = async () => {
      const { fechaVuelo, aerolinea, noVuelo } = formData;
      if (!fechaVuelo || !aerolinea || !noVuelo || !formData.int_nac) {
        alert('Todos los campos son requeridos');
        return;
      }
      try {
        await axios.post(`${API_BASE_URL}api/vuelos`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchVuelos();
        setIsFormOpen(false);
        setFormData({ ...formData, noVuelo: '' });
      } catch (error) {
        console.error('Error al guardar vuelo:', error);
        alert('Error al guardar vuelo');
      }
    };
  
    return (
      <div>
        {/* Burbuja flotante del avión */}
        <div
          className={`floating-bubble airplane ${isModalOpen ? 'bubble-active' : ''}`}
          onClick={() => setIsModalOpen(!isModalOpen)}
        >
          ✈️
        </div>
  
        {/* Modal */}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal modal-animate-in">
              <div className="modal-header">
                <h2>Vuelos Registrados</h2>
                <button className="close-button" onClick={() => setIsModalOpen(false)}>✖</button>
              </div>
              <button className="btn-submit" onClick={() => setIsFormOpen(true)}>Registrar Vuelo</button>
  
              {/* Formulario de vuelo */}
              {isFormOpen && (
                <div className="modal-body">
                  <label>Fecha:</label>
                  <input
                    type="date"
                    value={formData.fechaVuelo}
                    onChange={(e) => setFormData({ ...formData, fechaVuelo: e.target.value })}
                  />
  
                  <label>Aerolínea:</label>
                  <select
                    value={formData.aerolinea}
                    onChange={(e) => setFormData({ ...formData, aerolinea: e.target.value })}
                  >
                    <option value="">Selecciona una opción</option>
                    {aerolineasDisponibles.map((aero) => (
                      <option key={aero} value={aero}>{aero}</option>
                    ))}
                  </select>
  
                  <label>Número de Vuelo:</label>
                  <input
                    type="text"
                    value={formData.noVuelo}
                    onChange={(e) => setFormData({ ...formData, noVuelo: e.target.value })}
                  />

                  <label>Tipo de Vuelo:</label>
<select
  value={formData.int_nac}
  onChange={(e) => setFormData({ ...formData, int_nac: e.target.value })}
>
  <option value="">Selecciona una opción</option>
  <option value="INTERNACIONAL">INTERNACIONAL</option>
  <option value="NACIONAL">NACIONAL</option>
</select>

  
                  <button className="btn-submit" onClick={handleGuardarVuelo}>Guardar</button>
                </div>
              )}
  
              <div className="modal-body">
                <table className="bitacora-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Aerolínea</th>
                      <th>Vuelo</th>
                      <th>Tipo de Vuelo</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vuelos.map((vuelo) => (
                      <tr key={vuelo.idvuelo}>
                        <td>{moment(vuelo.fechaVuelo).format('YYYY-MM-DD')}</td>
                        <td>{vuelo.aerolinea}</td>
                        <td>{vuelo.noVuelo}</td>
                        <td>{vuelo.int_nac}</td>
                        <td>
                          <button onClick={() => eliminarVuelo(vuelo.idvuelo)} className="btn-close">🗑️</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
export default FloatingVuelosModal;
